import React, { Component } from 'react';
import { ButtonReg } from 'atoms/Buttons';
import Breadcrumb from 'molecules/Breadcrumb';
import CompanyFilter from 'molecules/CompanyFilter';
import DataTables from 'organisms/DataTable';
import { actionFormatter2, checkFormatter } from 'molecules/TableFormatters';
import { GET_DEPTS } from 'fixtures/api';
import { NewDept } from 'fixtures/TemplateData';
import { dashboardCreate, dashboardDelete, dashboardUpdate } from 'fixtures/permissions';
import { permissionCheck } from 'helpers/permissionCheckHelper';
import { postNewData, patchData, deleteData } from 'services/cmsService';
import { getAllDeptsData, editDeptData, addDeptData } from 'Redux/actions/DepartmentListActions';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { setLocalSettingsTableData } from 'Redux/actions/SettingsTableActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PageWrapper, TableWrapper } from './styles';
import lo from 'lodash';

import {
  TxtConfirmRenameDept,
  TxtConfirmDeleteDept,
  TxtSuccessDeleteDept,
  TxtFailedDeleteDept,
  TxtFailedSubmitData
} from 'fixtures/texts';

export class DepartmentList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      navList: [
        'Department',
        'Department List'
      ],
      allowCreate: false,
      allowDelete: false,
      allowUpdate: false,
    }

    this.fnEdit = {
      before: this.beforeSaveCell.bind(this),
      after: this.afterSaveCell.bind(this),
    }
  }

  componentDidMount() {
    this.props.toggleIsLoading(true)
    this.props.getAllDeptsData()
    this.checkPermission()
  }

  componentDidUpdate(prevProps) {
    const { deptsList, viewState: { isLoading }, userLogin } = this.props
    if (prevProps.deptsList !== deptsList && isLoading) {
      this.props.toggleIsLoading(false)
    }
    if (prevProps.userLogin !== userLogin) {
      this.checkPermission()
    }
  }

  // method for checking access permission
  checkPermission() {
    const { userLogin } = this.props
    if (userLogin && userLogin.userDetail) {
      const { userDetail: { permissions } } = userLogin
      this.setState({
        allowCreate: permissionCheck(permissions, dashboardCreate),
        allowDelete: permissionCheck(permissions, dashboardDelete),
        allowUpdate: permissionCheck(permissions, dashboardUpdate),
      })
    }
  }

  // method for switching the checkbox value
  switchCheck(row, field) {
    row[field] = !row[field]
    this.props.editDeptData(row)
    if (!row.isNew) {
      this.submitDept(row)
    }
  }

  // method for deleting department
  async onDeleteDept(dept) {
    const isOk = window.confirm(TxtConfirmDeleteDept)
    if (isOk) {
      const uri = `${GET_DEPTS}/${dept.id}`
      try {
        const res = await deleteData(uri)
        if (res.status !== 500) {
          alert(TxtSuccessDeleteDept)
          this.props.getAllDeptsData()
        } else {
          throw res
        }
      } catch (error) {
        alert(TxtFailedDeleteDept)
      }
    }
  }

  // method for confirming the cell changes
  beforeSaveCell(oldValue, newValue, row, column, done) {
    setTimeout(() => {
      const isOk = window.confirm(TxtConfirmRenameDept)
      done(isOk)
    }, 0);
    return { async: true };
  }

  // method for submitting changes after saving
  afterSaveCell(oldValue, newValue, row, column) {
    if (!row.isNew) {
      this.submitDept(row)
    }
  }

  // method for adding new department
  addNewDept() {
    this.props.addDeptData(lo.cloneDeep(NewDept))
  }

  // method for submitting department
  async submitDept(dept) {
    const { isNew, ...rest } = dept
    const sendObj = lo.cloneDeep(rest)
    const uri = sendObj.hasOwnProperty('createdAt') ?
      `${GET_DEPTS}/${sendObj.id}` :
      GET_DEPTS

    try {
      const patchObj = {
        nameDisplay: dept.nameDisplay,
        isAbleToView: dept.isAbleToView,
        id: dept.id,
      }
      const res = sendObj.hasOwnProperty('createdAt') ?
        await patchData(uri, patchObj) :
        await postNewData(uri, sendObj)
      if (res.status === 201 || res.status === 204) {
        this.props.getAllDeptsData()
      } else {
        throw res
      }
    } catch (err) {
      alert(TxtFailedSubmitData)
      this.setState({ isSubmitDisabled: false })
    }
  }

  onSizePerPageChange = (size) => {
    const { setLocalSettingsTableData, settingsTable } = this.props
    const settings = lo.cloneDeep(settingsTable)
    settings.sizePerPage[this.state.navList[0]] = size
    setLocalSettingsTableData(settings)
  }

  render() {
    const { navList } = this.state
    const { deptsList, settingsTable, viewState: { isLoading, isMobileView } } = this.props

    const sizePerPage = settingsTable.sizePerPage[navList[0]]

    const config = [
      {
        dataField: 'nameDisplay',
        text: 'Department Name',
        headerAttrs: { width: isMobileView ? 150 : 200 },
        editorStyle: (cell, row, rowIndex, colIndex) => {
          return { fontSize: '12px', padding: '0px 9px', maxHeight: '25px' };
        },
        sort: true
      },
      {
        dataField: 'isAbleToView',
        text: 'Able to View Other Departments',
        formatter: checkFormatter,
        formatExtraData: {
          allowEdit: this.state.allowUpdate,
          field: 'isAbleToView',
          fn: (row, field) => this.switchCheck.bind(this, row, field)
        },
        headerAttrs: { width: isMobileView ? 200 : 500 },
        headerAlign: 'center',
        align: 'center',
        editable: false,
        isDummyField: true
      },
      {
        dataField: 'action',
        text: 'Action',
        sort: false,
        headerAttrs: { width: isMobileView ? 100 : 150 },
        formatter: actionFormatter2,
        formatExtraData: {
          allowSave: this.state.allowCreate,
          allowDel: this.state.allowDelete,
          del: (row) => this.onDeleteDept.bind(this, row),
          save: (row) => this.submitDept.bind(this, row)
        },
        headerAlign: 'center',
        align: 'center',
        editable: false,
        isDummyField: true
      }
    ]

    return (
      <PageWrapper isMobile={isMobileView}>
        <Breadcrumb navList={navList}>
          <CompanyFilter />
        </Breadcrumb>
        {!isLoading &&
          <TableWrapper>
            <DataTables
              leftSlot={
                this.state.allowCreate &&
                <ButtonReg
                  btnTxt={'Add'}
                  disabled={false}
                  onClick={() => this.addNewDept()}
                  width={'78px'}
                />
              }
              isMobile={isMobileView}
              fnEdit={this.fnEdit}
              isInlineEdit={true}
              dataList={deptsList}
              columnConfig={config}
              sizePerPage={sizePerPage}
              onSizePerPageChange={this.onSizePerPageChange}
            />
          </TableWrapper>
        }
      </PageWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    deptsList: state.deptsList,
    userLogin: state.userLogin,
    viewState: state.viewState,
    settingsTable: state.settingsTable
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getAllDeptsData,
      editDeptData,
      addDeptData,
      toggleIsLoading,
      setLocalSettingsTableData,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DepartmentList);
